import { combineReducers } from 'redux'
import auth from '../modules/Authintication/store/reducer'
import common from '../modules/Common/store/reducer'
import teacher from '../modules/Teacher/store/reducer'

export default combineReducers({ auth, common, teacher })
